module.exports = __webpack_public_path__ + "img/copier-frame.6cf808df.gif";